import { render, staticRenderFns } from "./TurnaAspiranteDialogComponent.vue?vue&type=template&id=c92a83ae"
import script from "./TurnaAspiranteDialogComponent.vue?vue&type=script&lang=js"
export * from "./TurnaAspiranteDialogComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports